import { render } from "./GroupsIndex.vue?vue&type=template&id=48df8007&scoped=true"
import script from "./GroupsIndex.vue?vue&type=script&lang=js"
export * from "./GroupsIndex.vue?vue&type=script&lang=js"

import "./GroupsIndex.vue?vue&type=style&index=0&id=48df8007&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48df8007"]])

export default __exports__